// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountingNeedsSection_container__2aEM8","title":"AccountingNeedsSection_title__1TEYe","button":"AccountingNeedsSection_button__vhBNY"};